var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 308.653,
    viewBox: "0 0 332 308.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(-42.6 -54.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270197",
    "data-name": "Group 270197",
    transform: "translate(42.6 86.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497680",
    "data-name": "Path 497680",
    d: "M340.809,452.27H49.435a6.85,6.85,0,0,1-6.835-6.835h0a6.85,6.85,0,0,1,6.835-6.835H340.809a6.85,6.85,0,0,1,6.835,6.835h0A6.8,6.8,0,0,1,340.809,452.27Z",
    transform: "translate(-42.6 -175.64)",
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497681",
    "data-name": "Path 497681",
    d: "M345.482,238.814c-.154-.077-.23-.154-.384-.23-8.832-5.146-19.276-7.142-29.337-9.6-9.293-2.3-19.814-5.376-26.956-12.211-8.678-8.294-7.526-19.66-4.147-30.028,3.533-10.829,6.835-21.811,5.3-33.331A64.4,64.4,0,0,0,272.83,117.7C258.239,102.42,235.66,94.28,214,96.583c-29.03,3.072-52.914,23.116-71.039,44.774-11.9,14.208-18.892,30.412-32.486,43.929-13.44,13.363-28.492,25.42-39.7,40.55-15.053,20.121-22.348,45.849-17.433,70.117,4.838,24.192,22.656,46.31,47.077,55.065,15.513,5.606,32.563,5.683,49.151,5.76,34.483.077,69.042.154,103.448-2.458,22.656-1.69,45.542-4.685,66.2-13.67,20.582-8.985,38.86-24.729,45.618-45.234C371.516,275.063,364.528,250.181,345.482,238.814Z",
    transform: "translate(-44.739 -96.198)",
    fill: "#bfd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497682",
    "data-name": "Path 497682",
    d: "M66.29,216.868a11.433,11.433,0,0,0-3-5.069c-.768-.614-1.536-1.229-2.3-1.766a11.07,11.07,0,0,0-5.837-1.536h-.538a8.834,8.834,0,0,0-4.454,1,7.884,7.884,0,0,0-3.686,2.381,8.727,8.727,0,0,0-2.381,3.686,8.834,8.834,0,0,0-1,4.454c.154,1,.307,2.074.384,3.072a11.433,11.433,0,0,0,3,5.069c.768.614,1.536,1.229,2.3,1.766a11.07,11.07,0,0,0,5.837,1.536h.538a8.834,8.834,0,0,0,4.454-1,7.884,7.884,0,0,0,3.686-2.381,8.726,8.726,0,0,0,2.381-3.686,8.834,8.834,0,0,0,1-4.454C66.521,218.865,66.444,217.866,66.29,216.868Z",
    transform: "translate(-42.713 -122.251)",
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16780",
    "data-name": "Ellipse 16780",
    cx: 24.883,
    cy: 24.883,
    r: 24.883,
    transform: "translate(282.235 58.061)",
    fill: "#bfd2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270207",
    "data-name": "Group 270207",
    transform: "translate(48.129 54.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270200",
    "data-name": "Group 270200",
    transform: "translate(195.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270199",
    "data-name": "Group 270199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270198",
    "data-name": "Group 270198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497683",
    "data-name": "Path 497683",
    d: "M317.163,54.654a20.3,20.3,0,0,0-3.072.922c.077.077.154.154.154.23a2.78,2.78,0,0,1-4.685,3c-.077-.077-.077-.154-.154-.307a16.358,16.358,0,0,0-2.227,2.381.582.582,0,0,1,.307.154,2.783,2.783,0,0,1-2.611,4.915c-.077-.077-.23-.154-.307-.23a14.513,14.513,0,0,0-.768,3.149c.077,0,.23-.077.307-.077a2.766,2.766,0,0,1,.154,5.529h-.384a21.259,21.259,0,0,0,.922,3.149c.077-.077.23-.154.307-.23a2.78,2.78,0,0,1,3,4.685c-.154.077-.23.154-.384.154a16.885,16.885,0,0,0,2.381,2.3c.077-.154.077-.23.154-.384a2.783,2.783,0,1,1,4.915,2.611c-.077.154-.154.23-.23.384a16.39,16.39,0,0,0,3.226.768c0-.154-.077-.307-.077-.461a2.766,2.766,0,1,1,5.529-.154V87.6a17.3,17.3,0,0,0,3.226-1c-.077-.077-.154-.23-.23-.307a2.78,2.78,0,0,1,4.685-3c.077.154.154.23.23.384a17.461,17.461,0,0,0,2.3-2.458c-.154-.077-.23-.077-.384-.154a2.783,2.783,0,0,1,2.611-4.915,1.06,1.06,0,0,1,.307.23,14.155,14.155,0,0,0,.768-3.226c-.154,0-.23.077-.384.077a2.766,2.766,0,1,1-.154-5.529h.384a21.263,21.263,0,0,0-.922-3.149l-.23.23a2.78,2.78,0,0,1-3-4.685c.077-.077.23-.077.307-.154a16.36,16.36,0,0,0-2.381-2.227c0,.077-.077.154-.077.307a2.783,2.783,0,1,1-4.915-2.611c.077-.077.077-.154.154-.23a14.388,14.388,0,0,0-3.149-.691v.307a2.766,2.766,0,1,1-5.529.154A.462.462,0,0,1,317.163,54.654Zm2.918,6.835a9.6,9.6,0,1,1-9.293,9.907A9.609,9.609,0,0,1,320.081,61.489Z",
    transform: "translate(-303.8 -54.5)",
    fill: "#e6edff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270202",
    "data-name": "Group 270202",
    transform: "translate(0 42.009)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16781",
    "data-name": "Ellipse 16781",
    cx: 31.103,
    cy: 28.569,
    rx: 31.103,
    ry: 28.569,
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270201",
    "data-name": "Group 270201",
    transform: "translate(4.608 10.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497684",
    "data-name": "Path 497684",
    d: "M81.528,144.557,57.259,136.8a22.405,22.405,0,0,0-1.459,7.757c0,12.9,11.6,23.577,25.651,23.577a27.043,27.043,0,0,0,13.209-3.379Z",
    transform: "translate(-55.8 -125.664)",
    fill: "#628aec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497685",
    "data-name": "Path 497685",
    d: "M91,146.4l13.363,20.121a24.179,24.179,0,0,0,8.985-8.6,22.228,22.228,0,0,0,3.3-11.52Z",
    transform: "translate(-63.967 -127.892)",
    fill: "#bfd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497686",
    "data-name": "Path 497686",
    d: "M91.2,139.656l25.651-.307a22.946,22.946,0,0,0-2.227-9.293,24.492,24.492,0,0,0-6.067-7.757Z",
    transform: "translate(-64.013 -122.3)",
    fill: "#fefeff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270203",
    "data-name": "Group 270203",
    transform: "translate(91.237 16.588)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71131",
    "data-name": "Rectangle 71131",
    width: 9.293,
    height: 22.348,
    transform: "translate(4.992 26.035)",
    fill: "#628aec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71132",
    "data-name": "Rectangle 71132",
    width: 9.293,
    height: 33.254,
    transform: "translate(19.353 15.129)",
    fill: "#628aec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71133",
    "data-name": "Rectangle 71133",
    width: 9.293,
    height: 48.383,
    transform: "translate(33.715)",
    fill: "#628aec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71134",
    "data-name": "Rectangle 71134",
    width: 9.293,
    height: 27.187,
    transform: "translate(48.076 21.196)",
    fill: "#628aec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497687",
    "data-name": "Path 497687",
    d: "M168.6,76.7v47.769h63.512",
    transform: "translate(-168.6 -76.239)",
    fill: "none",
    stroke: "#628aec",
    strokeWidth: 0.876
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270206",
    "data-name": "Group 270206",
    transform: "translate(207.894 31.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270205",
    "data-name": "Group 270205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270204",
    "data-name": "Group 270204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497688",
    "data-name": "Path 497688",
    d: "M346.612,95.284a27.692,27.692,0,0,0-6.067,1.843c.154.154.23.307.384.461a5.4,5.4,0,0,1-9.139,5.76,1.925,1.925,0,0,0-.307-.538,31.085,31.085,0,0,0-4.378,4.608c.154.077.384.154.538.23a5.446,5.446,0,0,1-5.146,9.6,1.378,1.378,0,0,1-.538-.384,28.223,28.223,0,0,0-1.459,6.221c.23,0,.461-.077.691-.077a5.418,5.418,0,0,1,.384,10.829,2.612,2.612,0,0,1-.768-.077,34.149,34.149,0,0,0,1.843,6.221c.23-.154.384-.307.614-.461a5.4,5.4,0,1,1,5.76,9.139,7.138,7.138,0,0,1-.768.384,32.717,32.717,0,0,0,4.762,4.454,3.211,3.211,0,0,1,.307-.768,5.446,5.446,0,1,1,9.6,5.146c-.154.23-.307.538-.461.768a35.086,35.086,0,0,0,6.374,1.536c-.077-.307-.077-.538-.154-.845a5.418,5.418,0,1,1,10.829-.384,3.74,3.74,0,0,1-.077.922,35.14,35.14,0,0,0,6.3-1.92c-.154-.23-.384-.461-.538-.691a5.4,5.4,0,1,1,9.139-5.76,3.588,3.588,0,0,1,.384.768,37.193,37.193,0,0,0,4.454-4.762,3.21,3.21,0,0,1-.768-.307,5.446,5.446,0,0,1,5.146-9.6l.691.461a34.154,34.154,0,0,0,1.459-6.3,2.126,2.126,0,0,1-.691.077,5.418,5.418,0,0,1-.384-10.829,2.126,2.126,0,0,1,.691.077,31.807,31.807,0,0,0-1.92-6.144,1.378,1.378,0,0,1-.538.384,5.4,5.4,0,1,1-5.76-9.139,1.544,1.544,0,0,1,.614-.307,31.638,31.638,0,0,0-4.685-4.378c-.077.154-.154.384-.23.538a5.446,5.446,0,0,1-9.6-5.146,3.339,3.339,0,0,0,.307-.538,33.354,33.354,0,0,0-6.221-1.459c0,.154.077.384.077.538a5.418,5.418,0,0,1-10.829.384A1.138,1.138,0,0,0,346.612,95.284Zm5.606,10.214a22.131,22.131,0,1,1-21.35,22.886A22.088,22.088,0,0,1,352.218,105.5Z",
    transform: "translate(-320.5 -94.9)",
    fill: "#bfd2ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270237",
    "data-name": "Group 270237",
    transform: "translate(99.585 97.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270213",
    "data-name": "Group 270213",
    transform: "translate(116.645 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270208",
    "data-name": "Group 270208",
    transform: "translate(14.581 1.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497689",
    "data-name": "Path 497689",
    d: "M307.123,127.2a4.176,4.176,0,0,1-1.766-1.69c-.384-1.229.922-2.611.614-3.84-.307-1.075-1.536-1.536-2.688-1.69-1.075-.154-2.381-.307-3-1.229-.538-.768-.384-1.766-.538-2.688a4.887,4.887,0,0,0-3.456-3.994c-1.92-.538-3.61,1.229-5.222,1.92a5.453,5.453,0,0,0-3.226,4.147,13.039,13.039,0,0,0,.307,5.453,42.782,42.782,0,0,1,1.075,5.453,16.129,16.129,0,0,1-.845,5.76,6.145,6.145,0,0,0,.23,4.378,5.3,5.3,0,0,0,3.456,2.15,18.575,18.575,0,0,0,7.91.768,10.9,10.9,0,0,0,6.6-3.456,8.76,8.76,0,0,0,2.611-3.61A6.961,6.961,0,0,0,307.123,127.2Z",
    transform: "translate(-287.67 -111.969)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497690",
    "data-name": "Path 497690",
    d: "M294.86,119a4.66,4.66,0,0,1-.384,3.379c-.154.307-.461.691-.845.614-.461,0-.691-.538-.845-.922a13.719,13.719,0,0,1-.691-3.533c-.077-.768.077-2.074,1.152-1.843C293.938,116.922,294.629,118.3,294.86,119Z",
    transform: "translate(-288.693 -113.059)",
    fill: "#ff6ea1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_497691",
    "data-name": "Path 497691",
    d: "M289.432,142.067c-.768,2.688-5.146,3.994-7.68.922a10.993,10.993,0,0,1-.845-1.152c-2.688.538-6.758,1.69-8.6,3.917a6.956,6.956,0,0,0-1.152,2.534c-.922,3.226-1.766,6.528-2.381,9.83a1.725,1.725,0,0,0,.922,2.15c3.763,3,4.762,7.757,5.99,12.057,1.843,6.6,2.765,15.667,4.608,22.195,6.144.461,31.795-5.376,34.867-8.064-4.454-7.987-7.987-22.348-9.369-32.332a52.482,52.482,0,0,0-3.84-12.211c-.384-.922-.691-3.072-1.459-3.686-.922-.768-9.907.538-10.829.614,0,.538.077,1.075.077,1.613A5.982,5.982,0,0,1,289.432,142.067Z",
    transform: "translate(-268.685 -116.466)",
    fill: "#ff6ea1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270209",
    "data-name": "Group 270209",
    transform: "translate(10.38 14.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497692",
    "data-name": "Path 497692",
    d: "M283.429,135.6a12.1,12.1,0,0,0-1.229-2.688,7.575,7.575,0,0,0,4.224-1.459,15.357,15.357,0,0,0,1.69-1.459c.154-.154.461-.691.768-1-.384.461.614,3.149.768,3.686a8.728,8.728,0,0,0,1.843,3.149c.845.922,1.306,1.075,1.459,2.3a9.242,9.242,0,0,1-.614,4.07,4.1,4.1,0,0,1-1.382,2,3.655,3.655,0,0,1-2.842.23c-1.613-.384-3.763-1.766-4.378-3.379-.307-.845,0-1.306.154-2.227A8.022,8.022,0,0,0,283.429,135.6Z",
    transform: "translate(-282.2 -129)",
    fill: "#ffc1a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497693",
    "data-name": "Path 497693",
    d: "M283.966,138.446v-.307a9.316,9.316,0,0,0-.538-2.534,12.1,12.1,0,0,0-1.229-2.688,7.575,7.575,0,0,0,4.224-1.459,15.357,15.357,0,0,0,1.69-1.459c.154-.154.461-.691.768-1a9.6,9.6,0,0,0,.23,1.459A10.451,10.451,0,0,1,283.966,138.446Z",
    transform: "translate(-282.2 -129)",
    fill: "#e3856d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270212",
    "data-name": "Group 270212",
    transform: "translate(1.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497694",
    "data-name": "Path 497694",
    d: "M271.179,124.161a11.593,11.593,0,0,0,4.07,6.3,4.331,4.331,0,0,0,1.843,1,2.555,2.555,0,0,0,2-.307,3.65,3.65,0,0,0,1-2.688,26.641,26.641,0,0,0-.154-5.529,8.619,8.619,0,0,0-2.458-4.838c-1.075-1-4.147-2.534-5.529-1.075C270.334,118.478,270.718,122.318,271.179,124.161Z",
    transform: "translate(-270.779 -111.462)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_",
    transform: "translate(1.913 6.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497695",
    "data-name": "Path 497695",
    d: "M273.293,120.12c.23-1.766,2.227-.461,3.84-1.152,1.382-.614,2.458-1.229,3.994-1.075a5.51,5.51,0,0,1,3.763,1.69,6.684,6.684,0,0,1,.691.845,15.828,15.828,0,0,1,1.613,3.226v.077a10.449,10.449,0,0,1-1.459,6.144,5.728,5.728,0,0,1-4.915,3,4.814,4.814,0,0,1-3.149-1.229,10.783,10.783,0,0,1-2.3-3C274.6,126.878,273.063,122.04,273.293,120.12Z",
    transform: "translate(-273.27 -117.869)",
    fill: "#ffc1a6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_497696",
    "data-name": "Path 497696",
    d: "M280.515,121.588a23.466,23.466,0,0,1-5.606-1.613,5.989,5.989,0,0,1-3-3c-.614-1.382-.154-2.3.614-3.456a7.9,7.9,0,0,1,4.762-3.379c1.92-.538,4.378.23,6.221.922a7.265,7.265,0,0,1,3.379,2.227c1.536,1.843,2,4.992,1.92,7.219a11.114,11.114,0,0,1-.614,2.765c-.23.768-.614,1.613-1.536,1.766-.614.077-1.843-1.69-2.458-2.074a11.852,11.852,0,0,0-3.226-1.306C280.9,121.665,280.669,121.588,280.515,121.588Z",
    transform: "translate(-270.976 -109.965)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270210",
    "data-name": "Group 270210",
    transform: "translate(2.935 12.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497697",
    "data-name": "Path 497697",
    d: "M279.4,127.61a.543.543,0,1,0,.461-.614A.669.669,0,0,0,279.4,127.61Z",
    transform: "translate(-275.714 -125.967)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497698",
    "data-name": "Path 497698",
    d: "M280.175,125.691a1.689,1.689,0,0,0-1.075.154",
    transform: "translate(-275.644 -125.661)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497699",
    "data-name": "Path 497699",
    d: "M275,128.81a.543.543,0,1,0,.461-.614C275.149,128.272,274.919,128.5,275,128.81Z",
    transform: "translate(-274.688 -126.245)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497700",
    "data-name": "Path 497700",
    d: "M275.675,126.891a1.689,1.689,0,0,0-1.075.154",
    transform: "translate(-274.6 -125.939)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497701",
    "data-name": "Path 497701",
    d: "M277.484,129.1a2.453,2.453,0,0,1-.23,1.459.587.587,0,0,0-.154.384c0,.154.154.23.307.23a.576.576,0,0,0,.384-.077",
    transform: "translate(-275.18 -126.459)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497702",
    "data-name": "Path 497702",
    d: "M280.643,132.7a2.092,2.092,0,0,1-1.843.691",
    transform: "translate(-275.574 -127.294)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270211",
    "data-name": "Group 270211",
    transform: "translate(11.992 9.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497703",
    "data-name": "Path 497703",
    d: "M290.469,124.642a2.044,2.044,0,1,1-2.227-1.843A2.165,2.165,0,0,1,290.469,124.642Z",
    transform: "translate(-286.393 -122.794)",
    fill: "#ffc1a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497704",
    "data-name": "Path 497704",
    d: "M289.13,124.3a.945.945,0,0,0-.768.384,1.088,1.088,0,0,0-.077.845.737.737,0,0,1,.691-.154.578.578,0,0,1,.384.538",
    transform: "translate(-286.82 -123.143)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270214",
    "data-name": "Group 270214",
    transform: "translate(0 144.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497705",
    "data-name": "Path 497705",
    d: "M302.426,402.592H140.381a6.686,6.686,0,0,1-6.681-6.681V304.981a6.686,6.686,0,0,1,6.681-6.681H302.426a6.686,6.686,0,0,1,6.681,6.681v90.929A6.686,6.686,0,0,1,302.426,402.592Z",
    transform: "translate(-120.721 -298.3)",
    fill: "#dce4ff",
    stroke: "#485070",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497706",
    "data-name": "Path 497706",
    d: "M318.166,434.3H116.8a8.391,8.391,0,0,0,8.371,8.371H309.795A8.342,8.342,0,0,0,318.166,434.3Z",
    transform: "translate(-116.8 -329.854)",
    fill: "#bac5ef",
    stroke: "#485070",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497707",
    "data-name": "Path 497707",
    d: "M300.938,400.52H144.422A5.228,5.228,0,0,1,139.2,395.3V308.822a5.228,5.228,0,0,1,5.222-5.222H300.938a5.228,5.228,0,0,1,5.222,5.222V395.3A5.132,5.132,0,0,1,300.938,400.52Z",
    transform: "translate(-121.997 -299.53)",
    fill: "#545d78"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_497708",
    "data-name": "Path 497708",
    d: "M250.211,300.406a1.306,1.306,0,1,1-1.306-1.306A1.346,1.346,0,0,1,250.211,300.406Z",
    transform: "translate(-147.148 -153.847)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270231",
    "data-name": "Group 270231",
    transform: "translate(34.429 50.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270215",
    "data-name": "Group 270215"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71135",
    "data-name": "Rectangle 71135",
    width: 194.761,
    height: 132.554,
    transform: "translate(0 194.761) rotate(-90)",
    fill: "#fefeff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270224",
    "data-name": "Group 270224",
    transform: "translate(20.328 143.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270223",
    "data-name": "Group 270223",
    transform: "translate(10.291 5.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270216",
    "data-name": "Group 270216",
    transform: "translate(1.536 1.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497709",
    "data-name": "Path 497709",
    d: "M249.81,400.392l-17.664-21.964-15.36,19.66L203.5,383.727l1.766-1.613L216.633,394.4l15.513-19.814,17.126,21.427,9.984-20.352L280.3,371.9l.461,2.3-19.891,3.533Z",
    transform: "translate(-203.5 -371.9)",
    fill: "#e6edff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270217",
    "data-name": "Group 270217",
    transform: "translate(75.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497710",
    "data-name": "Path 497710",
    d: "M305.944,372.472a3.072,3.072,0,1,0-3.072,3.072A3.081,3.081,0,0,0,305.944,372.472Z",
    transform: "translate(-299.8 -369.4)",
    fill: "#ff6ea1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270218",
    "data-name": "Group 270218",
    transform: "translate(44.62 25.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497711",
    "data-name": "Path 497711",
    d: "M265.744,405.172a3.072,3.072,0,1,0-3.072,3.072A3.081,3.081,0,0,0,265.744,405.172Z",
    transform: "translate(-259.6 -402.1)",
    fill: "#628aec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270219",
    "data-name": "Group 270219",
    transform: "translate(54.681 3.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497712",
    "data-name": "Path 497712",
    d: "M278.844,377.172a3.072,3.072,0,1,0-3.072,3.072A3.081,3.081,0,0,0,278.844,377.172Z",
    transform: "translate(-272.7 -374.1)",
    fill: "#ffb861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270220",
    "data-name": "Group 270220",
    transform: "translate(26.956 3.61)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16782",
    "data-name": "Ellipse 16782",
    cx: 3.072,
    cy: 3.072,
    r: 3.072,
    fill: "#ffb861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270221",
    "data-name": "Group 270221",
    transform: "translate(12.057 22.809)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16783",
    "data-name": "Ellipse 16783",
    cx: 3.072,
    cy: 3.072,
    r: 3.072,
    fill: "#ff6ea1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270222",
    "data-name": "Group 270222",
    transform: "translate(0 10.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497713",
    "data-name": "Path 497713",
    d: "M207.644,386.072a3.072,3.072,0,1,0-3.072,3.072A3.132,3.132,0,0,0,207.644,386.072Z",
    transform: "translate(-201.5 -383)",
    fill: "#3fd4c7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_497714",
    "data-name": "Path 497714",
    d: "M188.1,361.9v41.471h92.542",
    transform: "translate(-188.1 -361.9)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270230",
    "data-name": "Group 270230",
    transform: "translate(18.715 13.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270228",
    "data-name": "Group 270228",
    transform: "translate(0.614 19.046)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71136",
    "data-name": "Rectangle 71136",
    width: 14.131,
    height: 32.793,
    transform: "translate(8.371 44.159)",
    fill: "#ffb861"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71137",
    "data-name": "Rectangle 71137",
    width: 14.131,
    height: 48.844,
    transform: "translate(30.182 28.108)",
    fill: "#ff6ea1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270227",
    "data-name": "Group 270227",
    transform: "translate(5.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270226",
    "data-name": "Group 270226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497715",
    "data-name": "Path 497715",
    d: "M194.2,253.454A129.4,129.4,0,0,0,238.59,220.2",
    transform: "translate(-194.2 -218.741)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270225",
    "data-name": "Group 270225",
    transform: "translate(43.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497716",
    "data-name": "Path 497716",
    d: "M252.888,218.3l-1,2.842-.384-1.229-1.306-.307Z",
    transform: "translate(-250.2 -218.3)",
    fill: "#485070"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71138",
    "data-name": "Rectangle 71138",
    width: 14.131,
    height: 71.039,
    transform: "translate(51.993 5.913)",
    fill: "#3fd4c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71139",
    "data-name": "Rectangle 71139",
    width: 14.131,
    height: 39.935,
    transform: "translate(73.803 36.94)",
    fill: "#628aec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497717",
    "data-name": "Path 497717",
    d: "M186.8,227.7v69.81h94.385",
    transform: "translate(-186.8 -220.481)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270229",
    "data-name": "Group 270229"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71140",
    "data-name": "Rectangle 71140",
    width: 94.769,
    height: 4.762,
    transform: "translate(0.077 102.833)",
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71141",
    "data-name": "Rectangle 71141",
    width: 56.908,
    height: 4.762,
    transform: "translate(18.892 8.371)",
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71142",
    "data-name": "Rectangle 71142",
    width: 94.769,
    height: 4.762,
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71143",
    "data-name": "Rectangle 71143",
    width: 94.769,
    height: 4.762,
    transform: "translate(0.077 111.588)",
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71144",
    "data-name": "Rectangle 71144",
    width: 94.769,
    height: 4.762,
    transform: "translate(0.077 120.343)",
    fill: "#e6edff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270236",
    "data-name": "Group 270236",
    transform: "translate(105.164 21.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270233",
    "data-name": "Group 270233",
    transform: "translate(11.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270232",
    "data-name": "Group 270232",
    transform: "translate(23.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497718",
    "data-name": "Path 497718",
    d: "M303.479,138.311c-1.075.23-2.227.538-3.3.845-.154.077-.384.077-.538.23-.23.154-.23.461-.307.691a14.267,14.267,0,0,0,2.458,10.829c.691.845,1.459,1.613,2.227,2.381.691.768,1.69,1.459,2.3,2.3a10.179,10.179,0,0,1,1.382,3.686,36.2,36.2,0,0,1,1.459,8.141c.154,1.843.23,3.917,1.613,5.069a4.158,4.158,0,0,0,4.992-.23,9.344,9.344,0,0,0,2.842-4.531,35.933,35.933,0,0,0,2.227-13.9c-.23-4.3-1.536-9.446-4.3-12.825a9.957,9.957,0,0,0-7.833-3.3A21.025,21.025,0,0,0,303.479,138.311Z",
    transform: "translate(-299.107 -137.685)",
    fill: "#ff6ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497719",
    "data-name": "Path 497719",
    d: "M308.3,167.012c1-5.529,2.074-11.059,3.072-16.512",
    transform: "translate(-301.24 -140.658)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497720",
    "data-name": "Path 497720",
    d: "M309.6,151.8c.384.922.691,1.766,1.075,2.688",
    transform: "translate(-301.541 -140.96)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_497721",
    "data-name": "Path 497721",
    d: "M279.339,183.833a3.184,3.184,0,0,1,1.229-.23c3.763-.077,7.373-.461,11.136-.845,2.534-.23,5.069-.384,7.526-.461,2,0,4.378.384,6.3-.154,2.074-.614,3.533-1.152,4.531-2.918a20.615,20.615,0,0,0,1.382-2.534,3.028,3.028,0,0,0,.384-1.536c-.154-.768-1-1.229-1.843-1.536-1.766-.614-2.842-1.613-4.838-1.843a21.283,21.283,0,0,0-6.221.461c-3.994.845-7.987,1.152-11.9,2.381a92.768,92.768,0,0,0-12.825,5.069,12.9,12.9,0,0,0-4.224,2.534,4.426,4.426,0,0,0-.461,5.99,1.931,1.931,0,0,0,1.766.768c.768-.154,1.229-1.075.614-1.382C275.96,189.132,276.036,184.985,279.339,183.833Z",
    transform: "translate(-268.544 -145.576)",
    fill: "#ffc1a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270235",
    "data-name": "Group 270235",
    transform: "translate(0 6.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270234",
    "data-name": "Group 270234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497722",
    "data-name": "Path 497722",
    d: "M266.154,188.23V188a1.091,1.091,0,0,0-.154.461C266,188.384,266.077,188.307,266.154,188.23Z",
    transform: "translate(-256.581 -155.721)",
    fill: "#ff6ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497723",
    "data-name": "Path 497723",
    d: "M273.753,147.3a2.675,2.675,0,0,0-1-1.075c-1.306-.768-4.07.384-5.222,1.075a6.752,6.752,0,0,1-.768.461,25.761,25.761,0,0,0-3.763,3.3,15.375,15.375,0,0,0-1.075,1.229c-5.453,6.221-8.909,13.133-8.064,21.5.154,1.766.538,3.763,1.92,4.915a4.463,4.463,0,0,0,3.994,1,7.288,7.288,0,0,0,3.533-1.92l-.077.307.23-.461c2.15-2.074,2.611-4.915,3.149-7.757h0c1.69-4.147,3.379-8.371,5.069-12.518C272.6,155.516,275.212,150.063,273.753,147.3Z",
    transform: "translate(-253.735 -145.969)",
    fill: "#ff6ea1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_497724",
    "data-name": "Path 497724",
    d: "M265.174,216.74c2.3-3.84-1.92-4.454-2.534-7.833a3.306,3.306,0,0,1,0-1.229c.614-3.686.845-7.373,1.152-11.213.23-2.534.538-5.069.922-7.526a40.322,40.322,0,0,0,1-5.3,12.754,12.754,0,0,0-.23-1.69,5.606,5.606,0,0,0-3.533-2.842,6.6,6.6,0,0,0-6.144,1.229,10.964,10.964,0,0,0-1.152,2.074,19.786,19.786,0,0,0-.461,5.606c.154,4.07-.23,8.141.23,12.134a97.073,97.073,0,0,0,2.842,13.44,14.053,14.053,0,0,0,1.843,4.531,4.712,4.712,0,0,0,6.144,1.229,1.981,1.981,0,0,0,1.075-1.69C266.48,216.817,265.635,216.2,265.174,216.74Z",
    transform: "translate(-253.835 -153.588)",
    fill: "#ffc1a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497725",
    "data-name": "Path 497725",
    d: "M268.9,178.731a43.025,43.025,0,0,1,5.837-14.131",
    transform: "translate(-257.254 -150.292)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497726",
    "data-name": "Path 497726",
    d: "M274,168.206c.691-.461,1.306-.845,2-1.306",
    transform: "translate(-258.437 -150.825)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270252",
    "data-name": "Group 270252",
    transform: "translate(49.051 206.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497727",
    "data-name": "Path 497727",
    d: "M115.84,292.128c2.842,3.3,3.994,7.68,4.992,11.827,1.229,5.3,2.534,10.675,3.763,15.974a16.04,16.04,0,0,1,.614,3.763,28.116,28.116,0,0,1-1,6.681c-.614,2.534-2.15,2.381-4.454,2.15-3.61-.384-8.448-1.459-10.905-4.378a10.366,10.366,0,0,1-1.843-5.069c-.461-2.458-.922-4.915-1.382-7.3-1.843-9.984-3.763-20.275-1.613-30.182A19.1,19.1,0,0,1,115.84,292.128Z",
    transform: "translate(-63.079 -260.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497728",
    "data-name": "Path 497728",
    d: "M123,334.767c1.613.768,3.072,1.69,4.608,2.611,2.458,1.459,4.992,2.458,7.449,3.84a8.039,8.039,0,0,0,2.227.922c1.306.23,2.765-.23,4.07-.077,1.766.23,3.3,1.843,3.994,3.917,1.075,3.533-1.459,2.227-3.149,1.92-1.306-.23-2.611-.461-3.994-.691a131.233,131.233,0,0,0-15.513-1.69c-2.918-.154-7.987-.077-10.137-2.688-1.075-1.306-2.227-6.912-.845-8.294a2.093,2.093,0,0,1,.922-.461,13.329,13.329,0,0,1,8.294-.154C121.539,334.153,122.307,334.46,123,334.767Z",
    transform: "translate(-64.938 -271.509)",
    fill: "#9c5240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270244",
    "data-name": "Group 270244",
    transform: "translate(0 41.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497729",
    "data-name": "Path 497729",
    d: "M107.859,386.99H57.1a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3h50.764a3,3,0,0,1,3,3h0A3,3,0,0,1,107.859,386.99Z",
    transform: "translate(-51.719 -324.476)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497730",
    "data-name": "Path 497730",
    d: "M51,330.056V312.238a4.818,4.818,0,0,1,4.838-4.838h39.7a4.818,4.818,0,0,1,4.838,4.838v17.817a4.818,4.818,0,0,1-4.838,4.838h-39.7A4.818,4.818,0,0,1,51,330.056Z",
    transform: "translate(-51 -307.4)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270238",
    "data-name": "Group 270238",
    transform: "translate(6.297 23.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71145",
    "data-name": "Rectangle 71145",
    width: 3.072,
    height: 36.633,
    fill: "#485070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270239",
    "data-name": "Group 270239",
    transform: "translate(39.474 23.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71146",
    "data-name": "Rectangle 71146",
    width: 3.072,
    height: 36.633,
    fill: "#485070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270240",
    "data-name": "Group 270240",
    transform: "translate(27.647 60.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71147",
    "data-name": "Rectangle 71147",
    width: 3.072,
    height: 44.543,
    fill: "#485070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270241",
    "data-name": "Group 270241",
    transform: "translate(4.531 60.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71148",
    "data-name": "Rectangle 71148",
    width: 3.072,
    height: 44.543,
    fill: "#485070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270242",
    "data-name": "Group 270242",
    transform: "translate(53.759 60.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71149",
    "data-name": "Rectangle 71149",
    width: 3.072,
    height: 44.543,
    fill: "#485070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270243",
    "data-name": "Group 270243",
    transform: "translate(38.015 60.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71150",
    "data-name": "Rectangle 71150",
    width: 3.072,
    height: 44.543,
    fill: "#485070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270246",
    "data-name": "Group 270246",
    transform: "translate(25.794 73.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497731",
    "data-name": "Path 497731",
    d: "M160.777,407.1c-1.766.384-2.918.461-4.992.768-3,.384-5.99.768-8.985,1,.768,5.376,1.536,10.137,1.69,11.136.768,4.147.384,14.515,2.227,18.508a28.482,28.482,0,0,0,6.3-.23C158.089,427.836,159.011,417.468,160.777,407.1Z",
    transform: "translate(-99.021 -361.959)",
    fill: "#cf9378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497732",
    "data-name": "Path 497732",
    d: "M130.676,402.648a9.451,9.451,0,0,0,.23,2.534,13.729,13.729,0,0,0,9.369,3.994,18,18,0,0,0,5.76-.768c.23-4.07.461-8.141.691-12.134.307-5.3.614-10.521,1.229-15.82a76.9,76.9,0,0,0,.077-14.208c-1.382-5.146-4.762-6.528-4.762-6.528a139.956,139.956,0,0,0-16.9-5.376c-8.985-2-18.124-3.456-27.187-5.376-4.378-.922-11.6-.768-13.9,3.994-2.611,5.53,2.611,12.825,6.758,15.974,4.3,3.3,9.677,4.915,14.976,6.067a99.738,99.738,0,0,0,22.886,2.227C129.678,377.151,130.676,400.728,130.676,402.648Z",
    transform: "translate(-84.587 -348.368)",
    fill: "#66a3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497733",
    "data-name": "Path 497733",
    d: "M129.931,377.1h0c-1.613-1.69-3.226-3.456-4.838-5.146-2.458-2.458-4.915-4.992-7.373-7.526-4.915-4.915-9.83-9.83-14.669-14.9-1.229-.23-2.534-.538-3.763-.768-4.378-.922-11.6-.768-13.9,3.994-2.611,5.53,2.611,12.825,6.758,15.974,4.3,3.3,9.677,4.915,14.976,6.067a90.976,90.976,0,0,0,22.809,2.3Z",
    transform: "translate(-84.61 -348.321)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497734",
    "data-name": "Path 497734",
    d: "M143.7,385.357c0-2.381.307-5.376.307-7.757",
    transform: "translate(-98.302 -355.115)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.398
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497735",
    "data-name": "Path 497735",
    d: "M145.134,358.4a113.919,113.919,0,0,0-21.734-5.3",
    transform: "translate(-93.592 -349.43)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270245",
    "data-name": "Group 270245",
    transform: "translate(50.268 69.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497736",
    "data-name": "Path 497736",
    d: "M170.959,454.027H151.068a.77.77,0,0,1-.768-.768V451.8h20.582v2.227Z",
    transform: "translate(-150.102 -442.267)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497737",
    "data-name": "Path 497737",
    d: "M170.668,450.21c.077-.077.154-.23.23-.307a2.876,2.876,0,0,0-1.075-3.226,8.876,8.876,0,0,0-3.379-1.459,66.7,66.7,0,0,0-7.757-1.766c-.691-.077-8.217-.768-8.141-1.152-.154,1.92-.23,3.763-.384,5.683a5.437,5.437,0,0,0,0,2.227Z",
    transform: "translate(-150.042 -440.063)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497738",
    "data-name": "Path 497738",
    d: "M154.647,440.088a3.576,3.576,0,0,1,4.147-.077,4.462,4.462,0,0,1,1.843,3.84,1.3,1.3,0,0,1-.23.768,1.482,1.482,0,0,1-.768.23c-1.152,0-2.381,0-3.533.077-.768,0-1.69.154-2.227-.461C152.957,443.16,153.8,440.933,154.647,440.088Z",
    transform: "translate(-150.839 -439.387)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497739",
    "data-name": "Path 497739",
    d: "M164.713,444.5a1.6,1.6,0,0,0-1.613,1",
    transform: "translate(-153.071 -440.571)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497740",
    "data-name": "Path 497740",
    d: "M165.7,446.5a2.129,2.129,0,0,1,1.766-1",
    transform: "translate(-153.675 -440.805)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497741",
    "data-name": "Path 497741",
    d: "M169.1,446.968a1.155,1.155,0,0,1,1.075-.768",
    transform: "translate(-154.463 -440.968)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270248",
    "data-name": "Group 270248",
    transform: "translate(18.294 71.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497742",
    "data-name": "Path 497742",
    d: "M118.21,403.175c-2.611.384-5.3.691-7.91.922,2,9.83,2.918,19.891,4.531,29.8,2.227,0,4.3-.461,6.681-.461.461-3,1.382-20.812,2.765-31.334A40.122,40.122,0,0,1,118.21,403.175Z",
    transform: "translate(-83.053 -359.4)",
    fill: "#cf9378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497743",
    "data-name": "Path 497743",
    d: "M102.452,404.329c.538,2.227,1.152,3.61,3.379,4.454a12.394,12.394,0,0,0,5.99.845,9.736,9.736,0,0,0,4.915-2.3s2.842-42.086-.691-47.461c-4.3-6.6-13.67-7.987-21.043-9.523-6.451-1.382-12.9-2.534-19.43-3.84-1.613,5.99-.461,13.056,1.843,18.585v.077a12.68,12.68,0,0,0,10.675,7.68,92.674,92.674,0,0,0,10.291.307C98.459,373.149,100.456,396.342,102.452,404.329Z",
    transform: "translate(-74.821 -346.5)",
    fill: "#66a3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497744",
    "data-name": "Path 497744",
    d: "M105.8,380.757c0-2.381.307-5.376.307-7.757",
    transform: "translate(-82.009 -352.648)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.398
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270247",
    "data-name": "Group 270247",
    transform: "translate(30.889 71.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497745",
    "data-name": "Path 497745",
    d: "M136.059,453.627H116.168a.77.77,0,0,1-.768-.768V451.4h20.582v2.227Z",
    transform: "translate(-115.125 -441.867)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497746",
    "data-name": "Path 497746",
    d: "M135.668,449.81c.077-.077.154-.23.23-.307a2.876,2.876,0,0,0-1.075-3.226,8.876,8.876,0,0,0-3.379-1.459,66.7,66.7,0,0,0-7.757-1.766c-.691-.077-8.217-.768-8.141-1.152-.154,1.92-.23,3.763-.384,5.683a5.436,5.436,0,0,0,0,2.227Z",
    transform: "translate(-115.042 -439.663)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497747",
    "data-name": "Path 497747",
    d: "M119.747,439.688a3.576,3.576,0,0,1,4.147-.077,4.462,4.462,0,0,1,1.843,3.84,1.3,1.3,0,0,1-.23.768,1.482,1.482,0,0,1-.768.23c-1.152,0-2.381,0-3.533.077-.768,0-1.69.154-2.227-.461C118.057,442.76,118.9,440.533,119.747,439.688Z",
    transform: "translate(-115.862 -438.987)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497748",
    "data-name": "Path 497748",
    d: "M129.813,444.1a1.6,1.6,0,0,0-1.613,1",
    transform: "translate(-118.095 -440.171)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497749",
    "data-name": "Path 497749",
    d: "M130.8,446.1a2.129,2.129,0,0,1,1.766-1",
    transform: "translate(-118.698 -440.405)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497750",
    "data-name": "Path 497750",
    d: "M134.2,446.568a1.155,1.155,0,0,1,1.075-.768",
    transform: "translate(-119.487 -440.568)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270249",
    "data-name": "Group 270249",
    transform: "translate(14.745 24.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497751",
    "data-name": "Path 497751",
    d: "M73.656,340.212c.154,1,.384,1.92.538,2.918,3.379-1.766,7.373-1.382,11.136-1.382a51.3,51.3,0,0,0,23.808-5.913,43.008,43.008,0,0,1-.922-6.067c0-2.074-.845-4.147-.845-6.221-.154-2.842,0-5.683.077-8.525.23-5.376.614-10.829-.384-16.128a23.5,23.5,0,0,0-4.07-9.677,13.5,13.5,0,0,0-3.763-3.763c-1.536-.768-3.917-.538-5.683-.691a16.056,16.056,0,0,0-3.84,0,12.13,12.13,0,0,0-4.378,1.843c-7.3,4.378-8.141,11.366-10.368,18.969-1.075,3.763-2.842,7.373-3.917,11.136a23.442,23.442,0,0,0-.845,6.528c.077,2,.845,3.763,1.152,5.683C72.274,332.609,72.965,336.449,73.656,340.212Z",
    transform: "translate(-70.2 -284.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497752",
    "data-name": "Path 497752",
    d: "M101.5,293.538a6.7,6.7,0,0,0,4.915,1.613,2.617,2.617,0,0,0,1.69-.538,1.5,1.5,0,0,0,.538-1.613",
    transform: "translate(-77.462 -286.581)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.398
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497753",
    "data-name": "Path 497753",
    d: "M99.4,314.3a17.78,17.78,0,0,0,10.752,11.366",
    transform: "translate(-76.975 -291.523)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.398
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497754",
    "data-name": "Path 497754",
    d: "M105.5,319.5a7.918,7.918,0,0,0,5.3,2.842",
    transform: "translate(-78.39 -292.729)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.398
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497755",
    "data-name": "Path 497755",
    d: "M93.4,319.1a37.4,37.4,0,0,0,9.677,15.667",
    transform: "translate(-75.583 -292.636)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.398
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497756",
    "data-name": "Path 497756",
    d: "M115.2,293.3c2.074,3.61,2.15,5.606,2.611,8.832a62.72,62.72,0,0,1,.691,10.752c-.077,5.99-1.382,11.52-.077,17.51",
    transform: "translate(-80.641 -286.65)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.398
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_",
    transform: "translate(34.252 16.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497757",
    "data-name": "Path 497757",
    d: "M106.275,281.065a11.97,11.97,0,0,1,1.306-2.842,8.893,8.893,0,0,1-4.531-1.536,12.062,12.062,0,0,1-1.843-1.613c-.23-.23-.538-.691-.845-1.075-.307,3.61-1.69,6.989-4.762,9.062a12.445,12.445,0,0,0,4.685,4.454c1.613.922,5.606,2.765,5.683-.538,0-1.075-.384-2.074-.307-3.149A17.86,17.86,0,0,1,106.275,281.065Z",
    transform: "translate(-95.6 -274)",
    fill: "#cf9378"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    transform: "translate(38.783 16.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497758",
    "data-name": "Path 497758",
    d: "M107.106,284.137v-.307a17.566,17.566,0,0,1,.538-2.765,11.97,11.97,0,0,1,1.306-2.842,8.893,8.893,0,0,1-4.531-1.536,12.062,12.062,0,0,1-1.843-1.613c-.23-.23-.538-.691-.845-1.075-.077.538-.154,1.075-.23,1.536A11.4,11.4,0,0,0,107.106,284.137Z",
    transform: "translate(-101.5 -274)",
    fill: "#9c5240"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_497759",
    "data-name": "Path 497759",
    d: "M75.1,292.151c-2.842,3.3-3.994,7.68-4.992,11.827-1.229,5.3-2.534,10.675-3.763,15.974-.461,1.843-1.152,4.378-.691,6.3a8.119,8.119,0,0,0,3.686,4.992c1.92,1.152,4.762,1.69,6.835.691,2.074-.922,4.378-1.92,5.837-3.686a10.366,10.366,0,0,0,1.843-5.069c.461-2.458.922-4.915,1.382-7.3C87.081,305.9,89,295.607,86.85,285.7A18.472,18.472,0,0,0,75.1,292.151Z",
    transform: "translate(-54.365 -260.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497760",
    "data-name": "Path 497760",
    d: "M91.312,307c-4.147,1.075-3.763,6.374-4.147,9.677A91.184,91.184,0,0,1,84.4,331.038",
    transform: "translate(-58.749 -265.399)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.398
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497761",
    "data-name": "Path 497761",
    d: "M89.4,309.386a7.8,7.8,0,0,1,2.534-3.686",
    transform: "translate(-59.909 -265.098)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.398
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497762",
    "data-name": "Path 497762",
    d: "M81.61,336.3c2.227.461,4.378,1.229,6.6,1.843,3.456,1.075,6.989,1.69,10.521,2.611a13.541,13.541,0,0,0,3.072.538c1.766,0,3.533-.691,5.3-.768a7.229,7.229,0,0,1,5.99,3.226c2.15,3.3-1.459,2.458-3.686,2.381-1.766,0-3.533-.077-5.3-.077a204.912,204.912,0,0,0-20.582.845c-3.763.307-10.445,1.229-13.824-1.075-1.613-1.075-4.378-6.451-2.842-7.987a3.014,3.014,0,0,1,1.075-.614,22.676,22.676,0,0,1,10.829-1.459C79.69,335.914,80.611,336.068,81.61,336.3Z",
    transform: "translate(-54.576 -272.042)",
    fill: "#cf9378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497763",
    "data-name": "Path 497763",
    d: "M152.454,339.9H152.3",
    transform: "translate(-74.503 -273.033)",
    fill: "#dc8b77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270250",
    "data-name": "Group 270250",
    transform: "translate(38.476 58.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497764",
    "data-name": "Path 497764",
    d: "M148.1,361.25H102.022a.887.887,0,0,1-.922-.922v-.307a.887.887,0,0,1,.922-.922H148.1a.887.887,0,0,1,.922.922v.307A.887.887,0,0,1,148.1,361.25Z",
    transform: "translate(-101.1 -336.214)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497765",
    "data-name": "Path 497765",
    d: "M157.434,354.336H116.5l3.533-23.577a1.711,1.711,0,0,1,1.613-1.459h37.708a1.545,1.545,0,0,1,1.536,1.843Z",
    transform: "translate(-104.673 -329.3)",
    fill: "#757e96"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16784",
    "data-name": "Ellipse 16784",
    cx: 2.688,
    cy: 2.688,
    r: 2.688,
    transform: "translate(32.947 9.446)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_",
    transform: "translate(38.553 6.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497766",
    "data-name": "Path 497766",
    d: "M115.715,263.206c-.461-1.843-2.458-.23-4.224-.845a7.893,7.893,0,0,0-4.378-.691,6.252,6.252,0,0,0-3.84,2.15,11.24,11.24,0,0,0-.691,1,20.571,20.571,0,0,0-1.382,3.61v.077a11.862,11.862,0,0,0,2.227,6.451,5.993,5.993,0,0,0,5.529,2.611,5.4,5.4,0,0,0,3.226-1.613,12.419,12.419,0,0,0,2.15-3.456C115.1,270.5,116.176,265.2,115.715,263.206Z",
    transform: "translate(-101.2 -261.572)",
    fill: "#cf9378"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_497767",
    "data-name": "Path 497767",
    d: "M106.393,262.945a.581.581,0,0,1,.077-.307l.461-2.3c1.92,1.459,3.994,3.456,6.528,4.3a4.832,4.832,0,0,0,5.222-1.613,5.726,5.726,0,0,0,.538-.922c.077-.154.23-.768.307-.768a1.69,1.69,0,0,1-2.15-.461,7.062,7.062,0,0,1-1.075-2.15,9.914,9.914,0,0,0-3.456-4.454,7.91,7.91,0,0,0-5.376-1.382,7.658,7.658,0,0,0-3.3,1.306,6.206,6.206,0,0,0-1.229,1.229c-.154.23-.845,1.459-.538,1.69a1.392,1.392,0,0,0-1.536-.077,3.287,3.287,0,0,0-1.075,1.229A10.646,10.646,0,0,0,98.56,265.1a12.9,12.9,0,0,0,.922,2.918c.307.768.845,1.69,1.766,1.69,1.306,0,1.152-2.227,1.536-3.379.154-.461.154-1,.691-1.152s1.459.922,1.843.077a1.485,1.485,0,0,0,0-1,1.148,1.148,0,0,1,.077-1h.845C106.317,263.252,106.393,263.175,106.393,262.945Z",
    transform: "translate(-62.004 -252.831)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497768",
    "data-name": "Path 497768",
    d: "M104.211,254a4.929,4.929,0,0,0-.538,4.915",
    transform: "translate(-63.124 -253.103)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497769",
    "data-name": "Path 497769",
    d: "M99.8,257.811a2.119,2.119,0,0,1,2.688.461",
    transform: "translate(-62.322 -253.919)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16785",
    "data-name": "Ellipse 16785",
    cx: 0.614,
    cy: 0.614,
    r: 0.614,
    transform: "translate(47.385 13.953)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497770",
    "data-name": "Path 497770",
    d: "M112.9,269.673a2.228,2.228,0,0,1,1.229,0",
    transform: "translate(-65.362 -256.718)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497771",
    "data-name": "Path 497771",
    d: "M118.829,272.414a.614.614,0,1,1-.614-.614A.606.606,0,0,1,118.829,272.414Z",
    transform: "translate(-66.452 -257.232)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497772",
    "data-name": "Path 497772",
    d: "M117.9,270.473a2.228,2.228,0,0,1,1.229,0",
    transform: "translate(-66.522 -256.904)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497773",
    "data-name": "Path 497773",
    d: "M116.33,273a2.209,2.209,0,0,0,.384,1.536.587.587,0,0,1,.154.384c0,.154-.154.23-.307.307H116.1",
    transform: "translate(-66.104 -257.511)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497774",
    "data-name": "Path 497774",
    d: "M112.9,277.2a2.534,2.534,0,0,0,2.074.538",
    transform: "translate(-65.362 -258.485)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270251",
    "data-name": "Group 270251",
    transform: "translate(38.399 11.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497775",
    "data-name": "Path 497775",
    d: "M101,269.727a2.227,2.227,0,1,0,2.227-2.227A2.229,2.229,0,0,0,101,269.727Z",
    transform: "translate(-101 -267.5)",
    fill: "#cf9378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497776",
    "data-name": "Path 497776",
    d: "M103.277,269.194a.914.914,0,0,1,.845.307.981.981,0,0,1,.154.922.572.572,0,0,0-.691-.077.684.684,0,0,0-.384.614",
    transform: "translate(-101.51 -267.888)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270262",
    "data-name": "Group 270262",
    transform: "translate(272.228 157.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270256",
    "data-name": "Group 270256",
    transform: "translate(8.294 69.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270253",
    "data-name": "Group 270253",
    transform: "translate(30.891 1.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497777",
    "data-name": "Path 497777",
    d: "M415.014,433.887c-.077-.307-7.91,1.075-8.755,1.229l-.077.077c-2.688,2.3-6.144,3.533-9.523,4.761a2.36,2.36,0,0,0-1.382.845c-1.536,1.766,1.69,2.534,2.842,2.688a22.777,22.777,0,0,0,5.606-.538c3.763-.691,7.6-.461,11.366-1.382a.422.422,0,0,0,.384-.23.462.462,0,0,0,.077-.307A24.531,24.531,0,0,0,415.014,433.887Z",
    transform: "translate(-393.145 -316.666)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497778",
    "data-name": "Path 497778",
    d: "M397.29,343.348c1.92,18.892,5.376,38.246,7.526,57.138,4.454.384,5.99.077,10.291-.614,2.842-20.505,3.994-30.412,1.459-51.225-.23-2.15,0-19.814-.077-22.118-.461-13.517,1.382-28.953-6.758-40.4-2.074-2.918-5.376-5.069-8.832-4.838a7.756,7.756,0,0,0-5.837,3.533c-4.224,5.683-1.843,21.2-1.075,27.955C394.909,321.614,396.445,334.363,397.29,343.348Z",
    transform: "translate(-392.623 -281.269)",
    fill: "#757e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497779",
    "data-name": "Path 497779",
    d: "M398.673,355.1c.768-3.3,1.69-6.528,2.611-9.753,3.226-11.289,4.531-22.963,6.144-34.559a50.371,50.371,0,0,0,.691-8.294c-.077-2.842-.384-5.683-.614-8.448a72.015,72.015,0,0,0-1.613-11.443,8.424,8.424,0,0,0-4.992-1.306,7.757,7.757,0,0,0-5.837,3.533c-4.224,5.683-1.843,21.2-1.075,27.955,1,8.985,2.458,21.657,3.379,30.643C397.674,347.185,398.135,351.1,398.673,355.1Z",
    transform: "translate(-392.623 -281.266)",
    fill: "#545d78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270254",
    "data-name": "Group 270254",
    transform: "translate(0 3.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497780",
    "data-name": "Path 497780",
    d: "M374.9,437.259h-.23a28.012,28.012,0,0,1-7.6-.077,2.185,2.185,0,0,0-1,0,2.4,2.4,0,0,0-.768.384,21.779,21.779,0,0,1-7.68,2.918c-1.536.307-3.226.461-4.454,1.459a1.541,1.541,0,0,0-.614,1.92,1.848,1.848,0,0,0,.614.461c2.381,1.075,5.913.691,8.448.538,4.07-.23,8.141,0,12.211-.768a1.092,1.092,0,0,0,.461-.154,1.543,1.543,0,0,0,.307-.614c.23-1.152.461-2.227.614-3.379.077-.461.307-2.074,0-2.458C375.209,437.259,375.056,437.259,374.9,437.259Z",
    transform: "translate(-352.4 -319.986)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497781",
    "data-name": "Path 497781",
    d: "M388.733,284.6c-9.293-.154-12.134,9.6-13.286,17.049-2.3,15.744-3.994,31.641-4.915,47.615-.461,7.91-1.075,14.592-1.382,22.579-.307,8.141-.691,22.272-.384,30.335a.564.564,0,0,0,.154.461.648.648,0,0,0,.538.154,57.482,57.482,0,0,0,10.291.154.564.564,0,0,0,.461-.154c.154-.077-1.152-.614-1.075-.768,2.611-8.064,4.378-22.579,5.222-31.027,1.69-17.664,5.376-34.867,11.981-51.225C402.864,304.413,406.551,284.907,388.733,284.6Z",
    transform: "translate(-356.171 -284.598)",
    fill: "#757e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497782",
    "data-name": "Path 497782",
    d: "M399.7,334.64a245.369,245.369,0,0,0,9.6-27.34",
    transform: "translate(-363.374 -289.865)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270255",
    "data-name": "Group 270255",
    transform: "translate(19.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497783",
    "data-name": "Path 497783",
    d: "M392.6,304.447h.077c.845.154,1.69.23,2.534.384.614.077,1.229.154,1.92.23a1.69,1.69,0,0,1,.614.077,11.345,11.345,0,0,0,1.613.077,3.74,3.74,0,0,1,.922.077h.691a56.85,56.85,0,0,0,11.981-.845c-.614-7.142-2.15-13.977-6.3-19.814-2.074-2.918-5.376-5.069-8.832-4.838a7.756,7.756,0,0,0-5.837,3.533,9.051,9.051,0,0,0-.845,1.459c-8.064-.154-11.673,7.987-13.44,14.822a35.023,35.023,0,0,0,5.76,2.611A63.391,63.391,0,0,0,392.6,304.447Z",
    transform: "translate(-377.7 -279.778)",
    fill: "#545d78"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270258",
    "data-name": "Group 270258",
    transform: "translate(40.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_",
    transform: "translate(4.517 17.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497784",
    "data-name": "Path 497784",
    d: "M401.793,217.108a10.9,10.9,0,0,0-.23-3.149,8.364,8.364,0,0,0,4.762.154,19.108,19.108,0,0,0,2.227-.845,9.856,9.856,0,0,1,1.152-.768c-.922,3.533-.845,7.142,1.306,10.137a12.427,12.427,0,0,1-5.914,2.534c-1.843.307-6.221.614-5.146-2.458.307-1,1.075-1.766,1.382-2.842A10.41,10.41,0,0,0,401.793,217.108Z",
    transform: "translate(-399.782 -212.5)",
    fill: "#f7b699"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_",
    transform: "translate(5.99 19.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497785",
    "data-name": "Path 497785",
    d: "M406.461,214.73a8.018,8.018,0,0,1-4.454-.23,10.707,10.707,0,0,1,.23,3.149,11.565,11.565,0,0,1-.461,2.765c0,.077-.077.154-.077.307.154,0,.384-.077.538-.077A11.2,11.2,0,0,0,406.461,214.73Z",
    transform: "translate(-401.7 -214.5)",
    fill: "#c46e58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_",
    transform: "translate(2.227 5.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497786",
    "data-name": "Path 497786",
    d: "M398.72,196.433c1.075-1.536,2.381.614,4.224.691,1.613.077,2.918,0,4.378.845a6.158,6.158,0,0,1,2.842,3.379,6.4,6.4,0,0,1,.307,1.152,21.372,21.372,0,0,1,0,3.84v.077a11.582,11.582,0,0,1-4.3,5.222,6.1,6.1,0,0,1-6.144.538,5.44,5.44,0,0,1-2.458-2.611,11.538,11.538,0,0,1-.768-3.994C396.8,203.422,397.568,198.123,398.72,196.433Z",
    transform: "translate(-396.8 -195.882)",
    fill: "#f7b699"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_497787",
    "data-name": "Path 497787",
    d: "M400.2,198.462c-1.459.23-2.688.461-3.994-.307a4.927,4.927,0,0,1-2.15-2.688,4.532,4.532,0,0,1-.154-1.075v-.845a1.726,1.726,0,0,0,2.227.307,8.827,8.827,0,0,0,1.766-1.613,10.176,10.176,0,0,1,4.838-2.918,8.074,8.074,0,0,1,5.53.538,6.515,6.515,0,0,1,2.611,2.381,6.227,6.227,0,0,1,.768,1.613c.077.23.307,1.613-.077,1.766a1.243,1.243,0,0,1,1.459.538,3.808,3.808,0,0,1,.614,1.536,9.818,9.818,0,0,1-.691,5.529c-.538,1.229-1.152,2.611-1.843,3.84a6.2,6.2,0,0,1-2.534,2.534,8.84,8.84,0,0,1-4.454.538,3.291,3.291,0,0,1-3.072-1.92,6.133,6.133,0,0,1-.384-2c0-.307-.154-2.227.077-2.381a2.183,2.183,0,0,1-.922.307.9.9,0,0,1-.845-.384,1.272,1.272,0,0,1,0-.922C399.353,201.3,399.737,199.844,400.2,198.462Z",
    transform: "translate(-393.9 -189.068)",
    fill: "#485070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497788",
    "data-name": "Path 497788",
    d: "M416.929,192.9a5.072,5.072,0,0,1-1.229,4.838",
    transform: "translate(-398.958 -189.957)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497789",
    "data-name": "Path 497789",
    d: "M419.588,197.966a2.238,2.238,0,0,0-2.688-.538",
    transform: "translate(-399.236 -190.953)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270257",
    "data-name": "Group 270257",
    transform: "translate(5.483 12.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497790",
    "data-name": "Path 497790",
    d: "M405.31,208.6A2.211,2.211,0,1,1,404,205.763,2.187,2.187,0,0,1,405.31,208.6Z",
    transform: "translate(-401.04 -205.64)",
    fill: "#f7b699"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497791",
    "data-name": "Path 497791",
    d: "M404.482,207.565a.979.979,0,0,0-.922,0,.845.845,0,0,0-.461.768.737.737,0,0,1,.691.154.572.572,0,0,1,.077.691",
    transform: "translate(-401.518 -206.06)",
    fill: "none",
    stroke: "#485070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270261",
    "data-name": "Group 270261",
    transform: "translate(0 23.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497792",
    "data-name": "Path 497792",
    d: "M366.42,239.934a2.046,2.046,0,0,1,1.306-1.536c.691-.23,1.843-.23,2.074-.922.077-.307.23-.461-.077-.691a2.263,2.263,0,0,0-1-.384,3,3,0,0,0-2.765,1.536c-.154.307-.384.691-.691.614-.154-.077-.23-.23-.307-.307-.384-.922.154-1.92.691-2.765a4.617,4.617,0,0,1,1.536-1.69,4.1,4.1,0,0,1,2.534-.307c1.766.154,3.533.23,4.992,1.306a11,11,0,0,0,1.152.845,12.729,12.729,0,0,0,3.3,1.459c-.384,1.229-.691,2.458-1.075,3.686a.268.268,0,0,1-.077.154h-.23c-2.074-.538-4.531-.922-6.6-1.306A19.623,19.623,0,0,0,366.42,239.934Z",
    transform: "translate(-346.99 -222.961)",
    fill: "#f7b699"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497793",
    "data-name": "Path 497793",
    d: "M381.137,234.6a13.059,13.059,0,0,0-2.842,8.6c1.382.538,2.688,1.075,4.07,1.613l1.382-6.451c.154-.614.691-2,.384-2.534C383.672,235.291,381.828,234.907,381.137,234.6Z",
    transform: "translate(-350.111 -223.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497794",
    "data-name": "Path 497794",
    d: "M395.618,239.669a29.822,29.822,0,0,0-3.456-1.843c-2.074-.922-4.3-1.69-6.374-2.458a13.067,13.067,0,0,0-2.458-.768c-2.3,2.458-3.072,6.528-2.842,10.061,2.381,2.074,5.914,3.379,8.6,4.992a24.316,24.316,0,0,0,4.608,2.534,8.457,8.457,0,0,0,5.146.461,3.28,3.28,0,0,0,2.15-1.613,3.138,3.138,0,0,0,.23-1.69A12.225,12.225,0,0,0,395.618,239.669Z",
    transform: "translate(-350.614 -223.234)",
    fill: "#545d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497795",
    "data-name": "Path 497795",
    d: "M348.349,256.74a6.424,6.424,0,0,1-.461-5.3,2.263,2.263,0,0,1,1.306-1.459,2.205,2.205,0,0,1,2.15.845,15,15,0,0,1,1.075,2.227,8.515,8.515,0,0,0,1.306,2.3,5.968,5.968,0,0,1,1.382,2.3,2.419,2.419,0,0,1-.614,2C352.5,261.578,349.271,258.43,348.349,256.74Z",
    transform: "translate(-342.974 -226.789)",
    fill: "#f7b699"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270259",
    "data-name": "Group 270259",
    transform: "translate(0 14.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497796",
    "data-name": "Path 497796",
    d: "M368.71,253.077l-11.673,5.606L341.6,244.706l11.673-5.606Z",
    transform: "translate(-341.6 -238.793)",
    fill: "#f4ae2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497797",
    "data-name": "Path 497797",
    d: "M367.347,252.857l-9.984,4.838L344,245.638l10.061-4.838Z",
    transform: "translate(-342.157 -239.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497798",
    "data-name": "Path 497798",
    d: "M356.262,243.868l-8.294,4.07-.768-.768,8.294-4.07Z",
    transform: "translate(-342.899 -239.721)",
    fill: "#c8ddf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497799",
    "data-name": "Path 497799",
    d: "M361.839,248.891l-8.371,4.07-.768-.768,8.294-3.994Z",
    transform: "translate(-344.175 -240.904)",
    fill: "#c8ddf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497800",
    "data-name": "Path 497800",
    d: "M363.639,250.568l-8.294,3.994-.845-.691,8.371-4.07Z",
    transform: "translate(-344.593 -241.275)",
    fill: "#c8ddf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497801",
    "data-name": "Path 497801",
    d: "M365.462,252.268l-8.294,3.994-.768-.768,8.294-3.994Z",
    transform: "translate(-345.034 -241.67)",
    fill: "#c8ddf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497802",
    "data-name": "Path 497802",
    d: "M367.339,253.891l-8.371,4.07-.768-.768,8.294-3.994Z",
    transform: "translate(-345.451 -242.064)",
    fill: "#c8ddf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497803",
    "data-name": "Path 497803",
    d: "M369.139,255.568l-8.294,3.993L360,258.87l8.371-4.07Z",
    transform: "translate(-345.869 -242.435)",
    fill: "#c8ddf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497804",
    "data-name": "Path 497804",
    d: "M353.384,241.465l-6.989,3.379-3-2.688,6.989-3.456Z",
    transform: "translate(-342.018 -238.7)",
    fill: "#485070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_497805",
    "data-name": "Path 497805",
    d: "M350.038,255.543a1.607,1.607,0,0,0-.307.461c-.845,1.382.845,2.765,1.92,3.456,2.458,1.766,5.453,2.534,8.294,3.379,1.613.461,6.3-.691,4.992-3.226-.845-1.766-3.456-2.765-5.222-3.226a4.758,4.758,0,0,1-3.994-2.842c-.307-.768-.384-1.69-.691-2.458a1.238,1.238,0,0,0-.307-.538.465.465,0,0,0-.614-.077.4.4,0,0,0-.154.307c-.461,1.382.384,2.458-1.306,3.226-.538.307-1.229.384-1.766.691A8.767,8.767,0,0,0,350.038,255.543Z",
    transform: "translate(-343.433 -226.898)",
    fill: "#f7b699"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497806",
    "data-name": "Path 497806",
    d: "M360.778,255.2a13,13,0,0,0-1.92,8.909c1.382.384,2.842.768,4.224,1.152.23-2.15.461-4.378.691-6.528.077-.691.461-2.074.077-2.534C363.312,255.584,361.392,255.354,360.778,255.2Z",
    transform: "translate(-345.572 -228.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497807",
    "data-name": "Path 497807",
    d: "M398.514,221.566a5.485,5.485,0,0,1,3.149-1c2.842-.23,5.683-.538,8.525-.768.538,1.92,1.075,3.84,1.613,5.683,0-.077-9.216.307-10.137.23-.922,0-3.917.307-4.3-.614C396.9,224.254,397.823,222.258,398.514,221.566Z",
    transform: "translate(-354.509 -219.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497808",
    "data-name": "Path 497808",
    d: "M412.326,269.933c0-3,.154-6.067.384-9.062.23-3.917.538-7.91.614-11.827a78.982,78.982,0,0,0-1-14.669c-.23-1.229-.461-2.381-.768-3.533-.077-.23-.154-.461-.23-.768-.922-2.15-2.611-5.069-4.915-6.374H405.26c-2.611.154-5.3.461-7.91.845-1.766.307-3.072.538-4.378,1.92-3.379,3.533-6.528,11.366-7.449,16.2-.845,4.608-.538,4.915-1,9.523-.538,5.529-1.382,11.059-2.458,16.512-.845,4.608-2.227,9.6-6.067,12.365,6.374,2.688,12.825,5.376,19.584,6.451,6.835,1.075,14.131.384,19.968-3.379C412.94,279.917,412.249,275,412.326,269.933Z",
    transform: "translate(-349.581 -220.705)",
    fill: "#757e96"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270260",
    "data-name": "Group 270260",
    transform: "translate(14.684 6.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497809",
    "data-name": "Path 497809",
    d: "M393.037,242.784a3,3,0,0,0-1.075-1.306,2.855,2.855,0,0,0-1.766-.384c-2.688.154-4.762,2.3-6.221,4.531s-2.534,4.838-4.531,6.528c-3.533,3-12.057.538-16.051-.307-3,2.918-3.3,6.374-1.766,10.368,5.3,2.3,16.512,7.91,22.272,5.146a12.254,12.254,0,0,0,4.762-4.531,30.4,30.4,0,0,0,1.92-3.456,34.707,34.707,0,0,0,3.226-8.064A12.906,12.906,0,0,0,393.037,242.784Z",
    transform: "translate(-360.72 -231.565)",
    fill: "#757e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497810",
    "data-name": "Path 497810",
    d: "M401.012,230.311a5.583,5.583,0,0,0-6.912-.768c-1.229.768-1.92,2.381-2.534,3.686a37.746,37.746,0,0,0-2,4.838c-.538,1.766-1,3.533-1.536,5.222-.845,2.842-2,5.606-2.688,8.525a15.033,15.033,0,0,0,.307,8.832c1.536,3.994,6.758,1.843,9.139-.384,2-1.92,3-4.608,3.84-7.219.922-2.611,1.766-5.222,2.688-7.833a30.527,30.527,0,0,0,1.766-7.987A9.534,9.534,0,0,0,401.012,230.311Z",
    transform: "translate(-366.315 -228.693)",
    fill: "#757e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497811",
    "data-name": "Path 497811",
    d: "M387.5,247.212a54.785,54.785,0,0,1,6.451-16.512",
    transform: "translate(-366.933 -229.158)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497812",
    "data-name": "Path 497812",
    d: "M402.748,245.7l-3.456,9.216c-.845,2.227-1.613,5.069-3.149,6.835a32.188,32.188,0,0,1-4.915,5.3,9.278,9.278,0,0,1-6.528,2.227",
    transform: "translate(-366.284 -232.639)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497813",
    "data-name": "Path 497813",
    d: "M409.058,246.8a6.5,6.5,0,0,0-2.458,2.534",
    transform: "translate(-371.365 -232.894)",
    fill: "none",
    stroke: "#485070",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_497814",
    "data-name": "Path 497814",
    d: "M362.682,242.181l-1.382.768.691-1.382,8.294-8.6a.573.573,0,0,1,.691,0h0a.573.573,0,0,1,0,.691Z",
    transform: "translate(-346.171 -222.828)",
    fill: "#485070"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.7456b6b49177dfc38272a0374c3a62a2.svg";
export { ForwardRef as ReactComponent };